import {
  SNAP_EXTENSION_DISTANCE_PX,
  SNAP_LINE_PENALTY_PX,
  SNAP_TOLERANCE_PX,
} from './snapTokens';

/**
 * The snapping distances resolved into viewBox user units for one zoom level.
 *
 * The geometry in ./guidelines works purely in user units and takes these as an
 * argument, so it stays free of any notion of the viewport. Resolve them once at the
 * interaction boundary (see context/MouseEvents/hooks/useSnapping) and pass them down.
 */
export type SnapMetrics = {
  /** Snap distance. */
  tolerance: number;
  /** How far snap lines project past their reference element. */
  extensionDistance: number;
  /** Ranking penalty applied to line candidates so points win ties. */
  linePenalty: number;
};

/**
 * `scale` is viewBox units per screen pixel, so larger means zoomed out. These are
 * deliberately uncapped, unlike handle geometry: a snap threshold is a hit test the
 * user performs with the mouse, so it should be the same number of screen pixels at
 * every zoom level, and zooming in is exactly how the user asks for finer placement.
 */
export const getSnapMetrics = (scale: number): SnapMetrics => ({
  tolerance: SNAP_TOLERANCE_PX * scale,
  extensionDistance: SNAP_EXTENSION_DISTANCE_PX * scale,
  linePenalty: SNAP_LINE_PENALTY_PX * scale,
});
